const images = {
	homeKlickLogo: require("./homeKlickLogo.png"),
};

export default images;
